
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's0b0a02a4470de153': `设备`,
's0fae70085395a77b': `导出分辨率`,
's12e9c9d9d9b94cf1': `屏幕截图`,
's166bd56d19670a72': `缩放`,
's191bbfc4126e2367': `动作`,
's1cfec4d5cba2e56c': `动作组`,
's1db6360db0fbd814': `平移 X`,
's1db6370db0fbd9c7': `平移 Y`,
's21b06c38fc4164db': `高级`,
's255857544a9d5ec0': `重置`,
's259a6b881cae3f83': `自定义导出高度`,
's2706a162264c46f1': `缩放`,
's3914cb410fca44d4': `导入`,
's49cbb899f39d446c': `无可用项`,
's54d1b2a64667e32e': `相机`,
's5efd695469fdfbc7': `拖放ZIP文件`,
's6ab73c998850c5ab': `表情`,
's81a28b03c630b0b4': `自定义导出宽度`,
's8a4ff2bd9c13498c': `录制`,
's8dd37619f42fa90c': `平移`,
'sa9da29c2219e79d4': `开始录制`,
'safebfdf2495fa963': `视口`,
'sb32cad250448883a': `停止录制`,
'scc8c6c80277c1d89': `分辨率缩放`,
'sd9ad53251f2330a5': `停止`,
'sdaa6b536b76a65f5': `光标跟踪`,
'sdcf7cff5142442e6': `切换全屏`,
'see3ba305d75e09c9': `构图指南`,
'sf0cab2483f66aa2e': `自定义`,
's07f84a07b4b98e4c': `1x`,
's41de11f116525cf3': `1.5x`,
's08034c07b4c39937': `2x`,
'sd745ea0ba1e14cec': `2.5x`,
's07ff4607b4bfa62e': `3x`,
    };
  